<template>
    <v-container :style="cssProps">
        <div class="forma-pagamento mx-auto">
            <div class="text-center d-flex align-start justify-center">
                <v-label v-if="!multiplasCotas">Selecione uma forma de pagamento</v-label>
                <label class="text--multiple_quotes" v-if="multiplasCotas && forma_pagamento == FormasPagamento.Boleto">Seu cliente receberá um e-mail contendo um boleto para cada cota comprada*</label>
            </div>

            <FormaToggle
                    v-model="forma_pagamento"
                    class="mt-5"
                    :multiplas-cotas="multiplasCotas"
                    :cartao="multiplasCotas ? formasPagamentoPermitidas.cartao : permitir_cartao"
                    :boleto="multiplasCotas ? formasPagamentoPermitidas.boleto : true"
                    :link="multiplasCotas ? formasPagamentoPermitidas.link : permitir_cartao"
                    :pagamento-atual="pedido.forma_pagamento" />

            <FormaCartao id="FormaCartao" v-if="forma_pagamento === FormasPagamento.Cartao && permitir_cartao"
                         v-model="cartao" :bandeiras-base="bandeiras_base" ref="form" class="mt-5" />

            <p v-if="forma_pagamento === FormasPagamento.Link" class="ml-12 pt-7 pr-12 pl-12 font-weight-bold">
                * Link enviado ao e-mail do cliente para conclusão do próprio pagamento via cartão de crédito ou boleto.
            </p>

            <div class="card-resumo text--primary text-center px-10 py-5 mt-3 mx-auto">
                <div class="text-primary-color" v-html="textoPrimeiraParcela || '-'"></div>
                <div class="text-primary-color py-1" v-if="multiplasCotas">
                    {{ textoCotas }}
                </div>
                <div class="text-primary-color mb-3">Valor total da 1ª parcela a pagar</div>
                <v-btn v-if="desconto" @click="swapAlterarValor" color="primary" style="font-size: 18px; box-shadow: 2px 2px 4px #000000;" id="alterar_valor_parcela">Alterar valor da 1ª parcela</v-btn>
                <div v-if="desconto && parseFloat(pedido.plano.valor_parcela) !== parseFloat(pedido.bem.vl_original)" style="">
                    <br />
                    *Valor original {{ pedido.bem.vl_original * quantidadeCotasVenda || 0 | money }}
                    <br />
                </div>
            </div>
        </div>

        <v-flex class="mt-9">
            <v-layout class="justify-end">
                <v-col v-if="forma_pagamento === FormasPagamento.Cartao" class="text-center red--text ml-12 mb-10">
                    Campos
                    obrigatórios *
                </v-col>
                <v-btn id="ButtonFinalizar" class="mt-5" color="primary" @click="verificarQuantidadeFiliais">
                    Confirmar
                </v-btn>
            </v-layout>
        </v-flex>

        <v-dialog v-model="show_aterar_valor" persistent max-width="500">
            <v-card>
                <v-toolbar class="text-center col-12">
                    <v-toolbar-title class="col-11">Alterar valor da 1ª parcela</v-toolbar-title>

                    <v-btn class="col-1" icon @click="show_aterar_valor = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-container class="container">
                    <v-flex class="col-12 text-center">
                        <label class="card-resumo text--bold text--primary">*Valor original <span v-if="multiplasCotas">total</span> {{ pedido.bem.vl_original * quantidadeCotasVenda || 0 | money }}</label>
                        <br />
                        <label class="label-style text--primary">Você pode reduzir até {{ porcentagem }}% do valor total da primeira parcela</label>
                        <MoneyTextField
                                label=""
                                outlined
                                v-model="valor_com_desconto"
                                :maxvalue="valor_parcela_original * quantidadeCotasVenda"
                                @focus="ultrapassado_vl_minimo = false"
                                id="valor_com_desconto"
                                maxlength="14" />
                    </v-flex>
                    <v-flex class="col-12">
                        <v-btn class="col-4" color="secondary" @click="show_aterar_valor = false" id="fechar"> Cancelar </v-btn>
                        <v-btn class="col-4  offset-md-4" color="primary" @click="ajustaValorMinimo" id="alterar"> Confirmar </v-btn>
                    </v-flex>
                </v-container>
            </v-card>
        </v-dialog>
        <ListDialog v-model="dialog_filial"
                    title="ESCOLHA A FILIAL"
                    :items="filiais_visiveis"
                    :search-keys="['CD_Filial_Venda','NM_Filial_Venda']"
                    @select="selecionarFilial"
                    :item-text="filialTextDialog" />
    </v-container>
</template>

<script>
  import Color from 'color'
  import moment from 'moment'
  import { FormasPagamento } from '@/plugins/constants'
  import { alert, notification, formatarMoedaBrl, unmask } from '@/plugins/helpers'
  import { colorRes } from '@/plugins/flavors'
  import FormaToggle from '@/views/cadastro/pagamento/FormaToggle'
  import FormaCartao from '@/views/cadastro/pagamento/FormaCartao'
  import { mapGetters, mapState } from 'vuex'
  import loadFiliais from '../mixins/loadFiliais'
  import realizarVendaMixin from '../mixins/realizarVendaMixin'
  import enviarBoletoMixin from '../mixins/enviarBoletoMixin'
  import { BoletoMensagens } from '../enums/boletos/messages'
  import { MENSAGENS_ENDERECO } from '../enums/endereco/messages'
  import { get } from 'lodash'
  import { AlertTypes } from '../plugins/alerts_types'
  import pagarVendaMultiplaMixin from '@/mixins/pagarVendaMultiplaMixin'
  import { sendAnalyticsEvent } from '@/plugins/googleAnalytics'

  export default {
    name: 'FormaPagamentoComponent',
    components: { FormaToggle, FormaCartao },
    mixins: [loadFiliais, realizarVendaMixin, enviarBoletoMixin, pagarVendaMultiplaMixin],
    props: {
      value: Object,
      fromAlterar: {
        type: Boolean,
        required: false,
        default: false
      },
      propostasSelecionadas: {
        type: Array,
        required: false,
        default: () => []
      }
    },
    data: () => ({
      permitir_cartao: false,
      dialog_filial: false,
      valorAlterado: '',
      show_aterar_valor: false,
      ultrapassado_vl_minimo: false,
      desconto: false,
      valor_minimo_desconto: null,
      valor_com_desconto: null,
      valor_parcela_original: null,
      hasDesconto: false,
      enable_alterar_valor: false,
      porcentagem: null,
      pedido: {
        id_documento: 0,
        id_empresa: 0,
        id_comissionado: 0,
        id_regiao_fiscal: 1,
        id_reserva: 0,
        status_pedido: '',
        data_venda: '',
        codigo_pagamento_cliente: '',
        seguro: true,
        cliente: {
          id_cliente: '',
          id_usuario: '',
          bloqueado: '',
          pessoa: '',
          politicamente_exposto: '',
          genero: '',
          cpf: '',
          cpf_socio: '',
          data_nascimento: '',
          data_nascimento_socio: '',
          nacionalidade: '',
          naturalidade: '',
          nome_completo: '',
          nome_mae: '',
          id_tipo_documento: '',
          numero_documento: '',
          orgao_expeditor: '',
          data_emissao: '',
          id_estado_civil: '',
          id_profissao: '',
          renda: '',
          telefone_celular: '',
          telefone_residencial: '',
          telefone_comercial: '',
          email: '',
          receber_boletos: '',
          cnpj: '',
          razao_social: '',
          data_fundacao: '',
          id_atividade: '',
          faturamento_medio: '',
          percentual_participacao: '',
          ativo: '',
          completo: '',
          nome_fantasia: '',
          endereco: {
            id_endereco: '',
            id_cliente: '',
            cep: '',
            endereco: '',
            numero: '',
            complemento: '',
            bairro: '',
            id_cidade: '',
            principal: '',
            ativo: '',
            cidade: {
              id_cidade: '',
              nome: '',
              uf: '',
              ddd: '',
              ativo: '',
              descricao: ''
            }
          }
        },
        instancia_cliente: {
          email: '',
          telefone_celular: '',
          telefone_comercial: ''
        },
        produto: {
          id_produto: ''
        },
        bem: {
          id_bem: '',
          nome_bem: '',
          valor_bem: ''
        },
        grupo: {
          id_grupo: '',
          cd_grupo: '',
          taxa_adm: '',
          pe_lance_fixo: '',
          pe_seguro: 0,
          dt_vencimento: '',
          dt_assembleia: ''
        },
        plano: {
          id_plano_venda: '',
          id_tipo_venda: '',
          prazo_comercializacao: '',
          tipo_negociacao: '',
          situacao_grupo: '',
          pz_restante: '',
          nome_plano: '',
          valor_parcela: ''
        },
        carrinho: {
          qt_cotas: 1
        }
      },
      cartao: {
        numero_cartao: '',
        nome_cliente: '',
        expiracao: '',
        bandeira: '',
        cvv: ''
      },
      forma_pagamento: FormasPagamento.Boleto,
      filiais_visiveis: [],
      vendedor: true,
      bandeiras_base: []
    }),
    computed: {
      ...mapState([
        'id_usuario',
        'id_empresa',
        'vendas_backoffice',
        'hierarquia_comercial'
      ]),
      ...mapGetters([
        'filiais'
      ]),
      textoPrimeiraParcela () {
        if (this.multiplasCotas) {
          const valorUnitario = this.pedido.bem.vl_c_desconto ? this.pedido.bem.vl_c_desconto : this.pedido.plano.valor_parcela
          const valorMultiplo = formatarMoedaBrl(valorUnitario * this.quantidadeCotasVenda)

          if (this.forma_pagamento === FormasPagamento.Cartao) {
            return `<strong>Valor total da transação: ${valorMultiplo}</strong>`
          }
          return `<strong>Valor total ${valorMultiplo}</strong>`
        }
        const valor = this.pedido.bem.vl_c_desconto ? this.pedido.bem.vl_c_desconto : this.pedido.plano.valor_parcela
        const valorFormatado = formatarMoedaBrl(valor)
        return valorFormatado
      },
      textoCotas () {
        const valorUnitario = this.pedido.bem.vl_c_desconto ? this.pedido.bem.vl_c_desconto : this.pedido.plano.valor_parcela
        const valorFormatado = formatarMoedaBrl(valorUnitario)
        if (this.forma_pagamento === FormasPagamento.Boleto) {
          return `${this.quantidadeCotasVenda} boletos de ${valorFormatado}`
        }
        return `${this.quantidadeCotasVenda} cotas de ${valorFormatado}`
      },
      rotas: () => ({
        vendas: '/vendas',
        pagamento: '/pagamento',
        boleto: '/proposta/boleto/enviar',
        desconto: '/proposta/descontar',
        configuracaoPagamento: '/configuracaopagamento/get'
      }),
      FormasPagamento: () => FormasPagamento,
      cssProps () {
        return {
          '--accentTransparent': Color(colorRes().accent).alpha(0.15)
        }
      },
      multiplasCotas () {
        return this.propostasSelecionadas && this.propostasSelecionadas.length > 1
      },
      quantidadeCotasVenda () {
        if (this.multiplasCotas) {
          return this.propostasSelecionadas.length
        }
        return 1
      },
      formasPagamentoPermitidas () {
        if (!this.multiplasCotas) return null

        const formasPagamento = this.propostasSelecionadas.map(proposta => proposta.forma_pagamento)
        const temBoleto = formasPagamento.includes(FormasPagamento.Boleto)

        if (temBoleto) {
          return {
            cartao: this.permitir_cartao,
            boleto: false,
            link: this.permitir_cartao
          }
        }

        return {
          cartao: this.permitir_cartao,
          boleto: true,
          link: this.permitir_cartao
        }
      }
    },
    watch: {
      forma_pagamento (val) {
        this.desconto = (this.hasDesconto)
        if (this.desconto) {
          this.pedido.plano.valor_parcela = parseFloat(this.pedido.bem.vl_c_desconto) > 0 ? this.pedido.bem.vl_c_desconto : this.pedido.bem.vl_original
        }
      },
      valor_com_desconto (val) {
        if (val && val > 0) {
          this.valorAlterado = '*'
          this.enable_alterar_valor = true
        } else {
          this.enable_alterar_valor = false
        }
      }
    },
    async mounted () {
      await this.loadFiliais()
    },
    created () {
      if (typeof this.$route.params.vendedor !== 'undefined') {
        this.vendedor = this.$route.params.vendedor
        this.bandeiras_base = this.$route.params.bandeiras_base
      }

      const pedidoId = this.multiplasCotas ? this.propostasSelecionadas[0].id_pedido : this.value.id_pedido

      this.$http.get(`${this.rotas.vendas}/${pedidoId}`)
        .then(async res => {
          res.data.cliente = { ...this.pedido.cliente, ...res.data.cliente }
          res.data.produto = { ...this.pedido.produto, ...res.data.produto }
          res.data.bem = { ...this.pedido.bem, ...res.data.bem }
          res.data.grupo = { ...this.pedido.grupo, ...res.data.grupo }
          res.data.plano = { ...this.pedido.plano, ...res.data.plano }
          this.pedido = { ...this.pedido, ...res.data }

          if (this.vendedor) {
            await this.loadBandeiras()
            await this.loadPermissaoVendaCartao()
          }
          this.$http.get(this.rotas.configuracaoPagamento)
            .then(result => {
              if (result.data) {
                this.hasDesconto = result.data.ativo
                this.desconto = result.data.ativo
                this.porcentagem = result.data.porcentagem
                this.valor_parcela_original = this.pedido.plano.valor_original
                this.valor_minimo_desconto = parseFloat(this.pedido.plano.valor_original - (this.pedido.plano.valor_original / 100 * this.porcentagem))
              }
            })
        })
    },
    methods: {
      async loadPermissaoVendaCartao () {
        await this.$http.get(`/proposta/cartao/venda_cartao/${this.id_usuario}/${this.id_empresa}`)
          .then(res => {
            this.permitir_cartao = res.data.permitido
            if (this.permitir_cartao) {
              this.forma_pagamento = FormasPagamento.Cartao
            }
          })
      },
      fechar () {
        this.$emit('fechar')
      },
      filialTextDialog (item) { return `${item.CD_Filial_Venda} - ${item.NM_Filial_Venda}` },
      selecionarFilial (filial) {
        this.$session.set('filial', filial)
        this.$http.post('/vendas/alterar_filial', {
          id_pedido: this.pedido.id_pedido,
          id_filial: filial['ID_Filial_Venda'],
          nm_filial: filial['NM_Filial_Venda'],
          cd_filial: filial['CD_Filial_Venda']
        })

        this.dialog_filial = false

        this.validarPedido()
      },
      ajustaValorMinimo () {
        let valor = this.valor_com_desconto / this.quantidadeCotasVenda
        if (parseFloat(valor) > 0 && parseFloat(valor) < this.valor_minimo_desconto) {
          this.ultrapassado_vl_minimo = true
          this.enable_alterar_valor = false
          notification(AlertTypes.WARN, 'O valor inserido ultrapassa o limite máximo de desconto. Por favor, altere o valor do desconto e tente novamente.')
        } else {
          this.ultrapassado_vl_minimo = false
          this.enable_alterar_valor = true

          if (parseFloat(valor) > 0 && parseFloat(valor) >= this.valor_minimo_desconto) {
            this.alterarValor(false)
            this.swapAlterarValor()
          }
        }
      },
      alterarValor (reset_desconto) {
        if (reset_desconto) {
          this.$http.post(this.rotas.desconto, { id_pedido: this.pedido.id_pedido, valor_com_desconto: 0 })
        } else {
          if (this.valor_com_desconto && this.valor_com_desconto > 0) {
            this.$http.post(this.rotas.desconto, { id_pedido: this.pedido.id_pedido, valor_com_desconto: this.valor_com_desconto / this.quantidadeCotasVenda })
              .then(result => {
                this.pedido.plano.valor_parcela = this.valor_com_desconto / this.quantidadeCotasVenda
                this.pedido.bem.vl_c_desconto = this.valor_com_desconto / this.quantidadeCotasVenda
                this.valor_com_desconto = null
              })
          }
        }
      },
      swapAlterarValor () {
        this.show_aterar_valor = !this.show_aterar_valor
      },
      verificarQuantidadeFiliais () {
        if (this.vendedor) {
          if (this.filiais_visiveis.length > 1) {
            this.dialog_filial = true
          } else {
            const filial = this.filiais_visiveis[0]
            this.selecionarFilial(filial)
          }
        } else {
          this.validarPedido()
        }
      },
      validarPedido () {
        const form = this.$refs.form
        if (!form || form.validate()) {
          const now = moment().format('YYYY-MM-DD')
          const data_validade = this.pedido.data_validade
          if (!data_validade || now < data_validade) {
            const { Cartao, Boleto, Link } = FormasPagamento
            const msg = {
              [Cartao]: 'cartão de crédito',
              [Boleto]: 'boleto',
              [Link]: 'link por e-mail'
            }
            alert({
              text: `Confirma a forma de pagamento escolhida como ${msg[this.forma_pagamento]}?`,
              buttons: {
                'Cancelar': () => true,
                'Confirmar': () => {
                  this.finalizar(this.pedido.instancia_cliente.email)
                }
              }
            })
          } else {
            notification(AlertTypes.WARN, 'Esta venda está expirada e não pode ser paga')
          }
        }
      },
      async enviarCartao () {
        try {
          this.$store.commit('setAdditionalLoadingText', 'Processando a transação do cartão, este processo pode levar alguns minutos!')
          const cartao = { ...this.cartao, numero_cartao: this.cartao.numero_cartao.replace(/\s+/g, '') }

          const resposta = await this.$http.post(
            this.rotas.pagamento,
            { id_pedido: this.pedido.id_pedido, cartao, id_usuario: this.vendedor ? this.id_usuario : 0 },
            { options: { showAdditionalLoadingText: true } }
          )

          this.$emit('input', this.pedido)

          let msg_sucesso = 'Pagamento com cartão de crédito realizado com sucesso!'
          let alertType = AlertTypes.SUCCESS
          if (!resposta.data.atualizou_pedido_bd_intermediario) {
            alertType = AlertTypes.WARN
            msg_sucesso += ' Contudo, houve um erro inesperado em nosso servidor, informe ao administrador do sistema. Por favor, não efetue um novo pagamento para essa venda.'
          }

          return { type: alertType, mensagem: msg_sucesso }
        } catch (err) {
          throw err
        }
      },
      async atualizarEmail (email) {
        const { id_cliente, email: email_antigo } = this.pedido.cliente

        if (email_antigo !== email) {
          await this.$http.patch(`/clientes/${id_cliente}/email`, { email })

          this.pedido.cliente.email = email

          this.$emit('input', this.pedido)
        }
      },
      async finalizar (email) {
        try {
          const enderecoValido = await this.verifyAddress(this.pedido)
          if (!enderecoValido) {
            notification(AlertTypes.ERROR, MENSAGENS_ENDERECO.ERRO_BUSCAR_ENDERECO)
            return
          }
          let objPagamento = null

          if (this.multiplasCotas) {
            const cartao = { ...this.cartao, numero_cartao: this.cartao.numero_cartao.replace(/\s+/g, '') }
            const id_usuario = this.vendedor ? this.id_usuario : 0
            const ids_pedidos = this.propostasSelecionadas
              .map(proposta => proposta.id_pedido)

            if (this.forma_pagamento === FormasPagamento.Cartao) {
              const valor = this.pedido.bem.vl_c_desconto ? this.pedido.bem.vl_c_desconto : this.pedido.plano.valor_parcela
              objPagamento = await this.pagarComCartaoAlterarPagamento(ids_pedidos, this.forma_pagamento, this.cartao.bandeira, cartao, id_usuario, this.propostasSelecionadas, valor)
            } else if (this.forma_pagamento === FormasPagamento.Link) {
              objPagamento = await this.gerarLinkPagamentoAlterarPagamento(ids_pedidos, email)
            } else {
              objPagamento = await this.gerarBoletoAlterarPagamento(ids_pedidos)
            }

            sendAnalyticsEvent(this.$gtag, 'forma_pagamento_selecionada', {
              forma_pagamento: this.forma_pagamento,
              id_usuario: this.$session.get('id_usuario'),
              pv: this.$session.get('id_ponto_venda'),
              comissionado: this.$session.get('id_comissionado'),
              hierarquia: this.$session.get('hierarquia_comercial'),
              id_documento: this.pedido.id_documento
            })
          } else {
            await this.realizarVenda(this.pedido.id_pedido, this.forma_pagamento, this.cartao.bandeira, false, false, this.fromAlterar)
            objPagamento = await this.pagamentoPropostaUnica(email)
          }

          if (this.forma_pagamento !== this.pedido.forma_pagamento && this.pedido.carrinho.id_carrinho && this.fromAlterar) {
            sendAnalyticsEvent(this.$gtag, 'alterar_forma_pagamento_carrinho', {
              forma_pagamento_antiga: this.pedido.forma_pagamento,
              forma_pagamento_nova: this.forma_pagamento,
              desconto: this.valor_com_desconto,
              id_usuario: this.$session.get('id_usuario'),
              hierarquia: this.$session.get('hierarquia_comercial'),
              cliente: {
                cpf_cnpj: this.pedido.cliente.pessoa === 'fisica' ? unmask(this.pedido.cliente.cpf) : unmask(this.pedido.cliente.cnpj) // CPF ou CNPJ
              }
            })
          }
          this.pedido.enviado = true

          const TextoPagamentoSucesso = objPagamento.mensagem
          notification(objPagamento.type, TextoPagamentoSucesso, '', false, false, true)

          this.fechar()
        } catch (err) {
          const erroApi = get(err, 'response.data.Msg_Erro', null)
          if (erroApi) {
            notification(AlertTypes.ERROR, erroApi)
          }
          notification(AlertTypes.ERROR, err, err.message)
        }
      },
      async verifyAddress (pedido) {
        const verifyAddressPayload = {
          id_costumer: pedido.cliente.id_cliente,
          person_type: pedido.cliente.pessoa,
          addresses: pedido.cliente.enderecos
        }

        try {
          const response = await this.$http.post('/customer/verify-address', verifyAddressPayload)
          return response.data.ok
        } catch (error) {
          console.error('Error verifying address:', error)
          throw error
        }
      },
      async pagamentoPropostaUnica (email) {
        let objPagamento = null
        switch (this.forma_pagamento) {
          case FormasPagamento.Boleto:
            await this.enviarBoleto(this.pedido.id_pedido, email, this.vendedor)
            objPagamento = { type: AlertTypes.SUCCESS, mensagem: BoletoMensagens.PAGAMENTO_SUCESSO_BOLETO }
            break
          case FormasPagamento.Cartao:
            objPagamento = await this.enviarCartao()
            break
          case FormasPagamento.Link:
            objPagamento = await this.enviarLinkPagamento(email)
            break
        }
        return objPagamento
      },
      async enviarLinkPagamento (email) {
        await this.$http.post('/proposta/linkpagamento', { id_pedido: this.pedido.id_pedido, email })
        return { type: AlertTypes.SUCCESS, mensagem: 'Em breve o cliente receberá o link para pagamento.' }
      },
      async loadBandeiras () {
        this.$http.get(`/pagamento/bandeiras/${this.$session.get('id_empresa')}`)
          .then(async (res) => {
            this.bandeiras_base = res.data
          })
          .catch(() => {
            notification(AlertTypes.ERROR, 'Não foi possível buscar as bandeiras')
          })
      }
    }
  }
</script>

<style scoped lang="scss">
.forma-pagamento {
    max-width: 600px;
}

.label-style {
    font-size: 14px;
}

.card-resumo {
    background-color: var(--accentTransparent);
    border-radius: 10px;
    font-size: 1.5rem;
    width: fit-content;
}

.text--multiple_quotes{
  color:var(--advice_friendly);
  font-size: 1.1rem;
  padding:8px;
}

.text-primary-color{
  color:var(--primary);
}
</style>
